import { useSelector } from "react-redux";
import { IActivePaymentGateways } from "repoV2/features/Payments/modules/PaymentGateways/IPaymentGateways.interface";
import { getPaymentGatewayConfigArray } from "repoV2/features/Payments/utils/Payments.utils";
import { LISTING_STATUSES } from "repoV2/features/Listing/Listing.constants";
import { IRepoV2ReduxState } from "repoV2/features/Common/modules/Reducer/Reducer.interface";
import { GATEWAYS_ENUM } from "repoV2/features/Payments/Payments.constants";
import { useCheckoutBasicDetailsContext } from "../CheckoutBasicDetailsContextProvider";
import { useCheckoutThemeContext } from "../CheckoutThemeContextProvider";

const useCheckoutPaymentGateways = () => {
    const { listingUuid, listingStatus } = useCheckoutBasicDetailsContext();
    const { font: stripeFont } = useCheckoutThemeContext();

    const priceDetails = useSelector(
        (state: IRepoV2ReduxState) =>
            state.checkoutPages.listingDetails[listingUuid]?.priceSection
    );

    const {
        creator_gateway_details: stripeGatewayDetails = [],
        is_international_creator: isInternationalCreator,
        stripe_connect_id: stripeConnectId,
        payment_gateway: activePaymentGateway = GATEWAYS_ENUM.NEW_JUSPAY,
    } = priceDetails?.data || {};
    /**
     * We convert activePaymentGateway into an array so that even if in future
     * we have multiple payment gateways enabled, then we will load all the active gateways
     */
    const activePaymentGateways: IActivePaymentGateways = Array.isArray(
        activePaymentGateway
    )
        ? activePaymentGateway
        : [activePaymentGateway];

    const paymentGatewayConfig = getPaymentGatewayConfigArray(
        activePaymentGateways,
        {
            stripeData: {
                creatorGatewayDetails: stripeGatewayDetails,
                isInternationalCreator,
                stripeConnectId,
                stripeFont,
            },
        }
    );

    const isListingLive = listingStatus === LISTING_STATUSES.LIVE;

    return {
        isCheckoutPagePriceSectionApiDataLoading: !priceDetails?.isFetched,
        paymentGatewayConfig,
        isListingLive,
    };
};

export default useCheckoutPaymentGateways;
